import _ from "lodash";

export default function nikoSubCategoriesSort(data) {
  const order = [
    "Enteral",
    "G-Tube",
    "Oral-Supplements",
    "Ostomy-Products",
    "Trach-Tube",
    "Respiratory---trachs-supply",
    "Urologicals",
  ];
  const sortedData = _.orderBy(
    data,
    [
      t => {
        const index = order.indexOf(t.subCategory && t.subCategory.abrv);
        return index === -1 ? 999 : index; 
      },
      t => new Date(t.dateCreated)
    ],
    ["asc", "asc"]
  );
  return sortedData;
}